"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/internal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAccountService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.InternalAccountService
 */
exports.InternalAccountService = {
    typeName: "spwn.account.v1.InternalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetFanById
         */
        getFanById: {
            name: "GetFanById",
            I: internal_service_pb_1.InternalAccountServiceGetFanByIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetFanByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetFanByFirestoreId
         */
        getFanByFirestoreId: {
            name: "GetFanByFirestoreId",
            I: internal_service_pb_1.InternalAccountServiceGetFanByFirestoreIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetFanByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetBrandByFirestoreId
         */
        getBrandByFirestoreId: {
            name: "GetBrandByFirestoreId",
            I: internal_service_pb_1.InternalAccountServiceGetBrandByFirestoreIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetBrandByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetBrandByIds
         */
        getBrandByIds: {
            name: "GetBrandByIds",
            I: internal_service_pb_1.InternalAccountServiceGetBrandByIdsRequest,
            O: internal_service_pb_1.InternalAccountServiceGetBrandByIdsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetBrandById
         */
        getBrandById: {
            name: "GetBrandById",
            I: internal_service_pb_1.InternalAccountServiceGetBrandByIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetBrandByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetBrands
         */
        getBrands: {
            name: "GetBrands",
            I: internal_service_pb_1.InternalAccountServiceGetBrandsRequest,
            O: internal_service_pb_1.InternalAccountServiceGetBrandsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetTenantByFirestoreId
         */
        getTenantByFirestoreId: {
            name: "GetTenantByFirestoreId",
            I: internal_service_pb_1.InternalAccountServiceGetTenantByFirestoreIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetTenantByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetTenantById
         */
        getTenantById: {
            name: "GetTenantById",
            I: internal_service_pb_1.InternalAccountServiceGetTenantByIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetTenantByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetTenantOwnerByBrandId
         */
        getTenantOwnerByBrandId: {
            name: "GetTenantOwnerByBrandId",
            I: internal_service_pb_1.InternalAccountServiceGetTenantOwnerByBrandIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetTenantOwnerByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetCoreFanByBrandIdAndUserId
         */
        getCoreFanByBrandIdAndUserId: {
            name: "GetCoreFanByBrandIdAndUserId",
            I: internal_service_pb_1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.InternalAccountService.GetCoreFansByBrandId
         */
        getCoreFansByBrandId: {
            name: "GetCoreFansByBrandId",
            I: internal_service_pb_1.InternalAccountServiceGetCoreFansByBrandIdRequest,
            O: internal_service_pb_1.InternalAccountServiceGetCoreFansByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map